import { Stack, Text } from "@chakra-ui/react";
import { useTextVariants } from "@/theme/components/useSectionHeading";
import k8Clusters from "public/privateCloud/k8-clusters.png";

type DescCompProps = {
  description: string[];
};

const DescComp = (props: DescCompProps) => {
  const TextVariant = useTextVariants();
  const { description } = props;
  return (
    <Stack spacing={2}>
      {description.map((desc, index) => (
        <Text key={index} variant={TextVariant} color="text.100">
          {desc}
        </Text>
      ))}
    </Stack>
  );
};

export const INTRO_CONSTANTS = {
  heading: "Custom-built clusters for your architecture. ",
  title: "Onemind Private Kubernetes Clusters",
  description: (
    <DescComp
      description={[
        "With OneMind’s Managed Kubernetes Services, businesses gain access to a fully managed, enterprise-ready Kubernetes environment—without the complexity. We handle the operational heavy lifting, so teams can focus on building, shipping, and scaling applications. From workload orchestration to seamless integration with your CI/CD pipelines, everything is designed for efficiency, speed, and reliability.",
        "For organizations with stricter compliance or security requirements, we offer Private Kubernetes Clusters. These clusters operate entirely within a private network—no public access points—ensuring internal traffic stays secure and isolated. This setup offers all the flexibility of Kubernetes, with the control and privacy your infrastructure demands.",
        "Whether you’re running apps at the edge, in a hybrid cloud, or fully virtualized, OneMind makes Kubernetes work the way it should: scalable, secure, and fully managed.",
      ]}
    />
  ),
  points: [
    "Network-isolated clusters for enhanced security ",
    "Built-in auto-scaling and self-healing capabilities ",
    "Seamless integration with hybrid cloud environments ",
  ],
  image: k8Clusters,
  imageHeight: "450px",
};
